import { documentationApiClient } from "./clients";
import { CustomersResponse } from "types/documentationApi.types";

export const getCustomers = () =>
  documentationApiClient.request<CustomersResponse>({
    method: "GET",
    url: "/v1/customers",
  });
